import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';
import Modal from '../../normal-modal';
import CameraDisabledIcon from '../../../assets/svgs/exercise/camera-disabled-icon.svg';
import CameraDisabledWarningBadge from '../../../assets/svgs/exercise/camera-disabled-warning-badge.svg';
import CloseIcon from '../../../assets/svgs/exercise/modal-close-icon.svg';
import { CameraAnimation } from '../../camera-permission/content-side/content-side';

const CameraDisabledInfo = ({ onOpen, onClose }) => {
  const { t } = useTranslation('exercise');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    onOpen?.();
  };

  const closeModal = () => {
    setIsModalOpen(false);
    onClose?.();
  };

  // Figma "Get Ready screen - Camera enabled" (node 883-4798): Refresh
  // reloads the page so the browser re-prompts for camera access.
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <>
      <button
        type="button"
        tw="relative flex h-10 w-10 items-center justify-center"
        onClick={openModal}
        aria-label={t('cameraDisabledInfo.toggleAriaLabel')}
        title={t('cameraDisabledInfo.toggleAriaLabel')}
      >
        <img loading="lazy" decoding="async" src={CameraDisabledIcon} alt="" tw="h-full w-full" />
        <img loading="lazy" decoding="async" src={CameraDisabledWarningBadge} alt="" tw="absolute -right-0.5 -top-0.5 h-3 w-3" />
      </button>
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          handleClose={closeModal}
          hideIcon
          containerModalStyle={tw`w-[856px]! max-w-[92vw]! min-w-0! h-auto! max-h-[90vh]! overflow-y-auto! rounded-[12px]!`}
          content={
            <div>
              <div tw="hidden md:flex w-full items-center justify-end border-b border-[#bdc4c9] py-[14px] pl-8 pr-3.5">
                <button
                  type="button"
                  onClick={closeModal}
                  aria-label={t('cameraDisabledInfo.close')}
                  tw="flex h-[50px] w-[50px] items-center justify-center rounded-full"
                >
                  <img loading="lazy" decoding="async" src={CloseIcon} alt="" tw="h-6 w-6" />
                </button>
              </div>
              <div tw="hidden md:flex w-full items-stretch gap-8 p-8">
                <div tw="flex flex-1 flex-col gap-6 min-w-0">
                  <p tw="text-[48px] font-bold leading-[1.35] text-[#2e2e2e]">
                    {t('cameraDisabledInfo.title')}
                  </p>
                  <p tw="text-[24px] leading-[1.55] text-[#656565]">
                    {t('cameraDisabledInfo.description')}
                  </p>
                </div>
                <div tw="relative flex flex-1 min-w-0 h-[251px] items-center justify-center overflow-hidden rounded-[12px] bg-[#d1d1d1]">
                  <CameraAnimation />
                </div>
              </div>

              {/* Mobile only (Figma "Get Ready screen - Camera enabled",
                  node 883-4798). md and up keep the panel above, untouched. */}
              <div tw="md:hidden flex flex-col items-start gap-[12px] pt-[24px] px-[24px] w-full">
                <p tw="text-[32px] font-bold leading-[1.35] text-[#2e2e2e] w-full">
                  {t('cameraDisabledInfo.title')}
                </p>
                <p tw="text-[15px] font-normal leading-[1.55] text-[#656565] w-full">
                  {t('cameraDisabledInfo.description')}
                </p>
                <p tw="text-[16px] font-medium leading-[1.33] text-[#0059d8] w-full">
                  {t('cameraDisabledInfo.refreshHint')}
                </p>
              </div>
              <div tw="md:hidden flex flex-col gap-[12px] items-start pt-[32px] pb-[24px] px-[24px] w-full">
                <button
                  type="button"
                  onClick={handleRefresh}
                  tw="w-full rounded-[6px] border border-[#8da12b] bg-[#c6d86e] px-[16px] py-[10px] text-[15px] font-medium text-[#2e2e2e]"
                >
                  {t('cameraDisabledInfo.refresh')}
                </button>
                <button
                  type="button"
                  onClick={closeModal}
                  tw="w-full rounded-[6px] border border-[#bdc4c9] bg-white px-[16px] py-[10px] text-[15px] font-medium text-[#2e2e2e]"
                >
                  {t('settingsModal.cancel')}
                </button>
              </div>
            </div>
          }
        />
      )}
    </>
  );
};

export default CameraDisabledInfo;
